import { render, staticRenderFns } from "./NoWidgets.vue?vue&type=template&id=68154df0&scoped=true"
import script from "./NoWidgets.vue?vue&type=script&lang=js"
export * from "./NoWidgets.vue?vue&type=script&lang=js"
import style0 from "./NoWidgets.vue?vue&type=style&index=0&id=68154df0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68154df0",
  null
  
)

export default component.exports